import React, { Fragment, useState, useContext, useEffect, Component } from "react";

import { GlobalContext } from "./PA";

import "./ModalExample.css";

import Modal from "xsolla-uikit/lib/modal";

import Head from "xsolla-uikit/lib/head";
import FormFooter from "xsolla-uikit/lib/form-footer";
import Button from "xsolla-uikit/lib/button";
import StepTabs from "xsolla-uikit/lib/step-tabs";
import Collapse from "xsolla-uikit/lib/collapse";
import SelectExample from "./SelectExample";

import {
  // FormFooter,
  ModalAlert,
  Input,
  FormGroup,
  // Modal,
  // Button,
  StatusDot,
  Icon,
  Select,
  // Head,
  Checkbox,
  Textarea,
  ImagePicker
} from "xsolla-uikit";
import { throws } from "assert";

class ExampleStepTabs extends Component {
  constructor(props) {
    super(props);
    this.state = {
      current: props.current || 1
    };
    this.handleStep = props.handleStep || null;
  }

  setCurrent = current => this.setState({ current });

  handleStepClick = newStep => {
    this.setCurrent.bind(this, newStep);
    this.handleStep && this.handleStep(newStep);
  };

  steps = [
    { label: "Settings" },
    { label: "Test Results" }
    // {label: 'Test Results', disabled: true},
  ].map((step, index) => ({
    ...step
    // onClick: this.handleStepClick(index + 1)
  }));

  render() {
    return (
      <Fragment>
        <FormGroup>
          <StepTabs current={this.props.current} steps={this.steps} />
        </FormGroup>
      </Fragment>
    );
  }
}






export default function ({globalState, handleCurrentState, handleModal}) {
  let globalContext = useContext(GlobalContext);
  let [state, setState] = useState(
    {
      ...globalContext,
      current: 1
    }
  )


  const closeModal = (webhooksTested = false) => {
    handleModal();
    globalContext.handleCurrentState("globalWebhooks", {
      ...globalContext.globalState.globalWebhooks,
      value: webhooksTested
    })
  }



  const handleSteps = newStep => {
    setState({ current: newStep });
  }


    return (
      <div>
        {/* <Head>Modal</Head>
        <Button
          onClick={() =>
            this.setState({
              isFormModalOpen: true
            })
          }
        >
          Show Modal
        </Button> */}

        <div>
          <div className="xsui-modal xsui-modal--size-md">
            <div className="xsui-modal__overlay" />
            <div className="xsui-modal__entry">
              <div
                className="xsui-modal__close"
                data-id="close_modal"
                onClick={() => closeModal(false)}
              />
              <div className="xsui-content-block xsui-content-block--appearance-modal">
                <div className="xsui-content-block__entry xsui-head--align-center xsui-head--indentation-lg">
                  {/* <form> */}
                  <div className="xsui-head xsui-head--appearance-primary xsui-head--align-center xsui-head--indentation-lg">
                    <div className="xsui-head__title">Webhooks Setup</div>
                  </div>

                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center"
                    }}
                  >
                    <div style={{ width: "400px" }}>
                      <ExampleStepTabs
                        current={state.current}
                        // handleSteps={handleSteps.bind(this)}
                      />
                    </div>
                  </div>
                </div>
                <div className="xsui-content-block__entry xsui-head--align-center xsui-head--indentation-lg">



                  {state.current === 1 && (
                    <div className="xsui-form-group xsui-form-group--primary xsui-form-group--direction-column xsui-form-group--indentation-md">
                      <div
                      // className="webhooks-block__form"
                      >
                        <div style={{ width: "100%" }}>
                          <div className="xsui-form-group xsui-form-group--primary xsui-form-group--direction-column xsui-form-group--indentation-md">
                            <div className="xsui-form-group__label">
                              Webhook URL
                              <div className="xsui-tooltip xsui-tooltip--offset-left">
                                <div
                                  aria-describedby="tippy-tooltip-7"
                                  data-original-title="undefined"
                                  style={{ display: "inline" }}
                                >
                                  <div className="xsui-tooltip__button" />
                                </div>
                              </div>
                            </div>
                            <div className="xsui-form-group__entry">
                              <div style={{ display: "block" }}>
                                <div
                                  style={{
                                    position: "relative",
                                    width: "100%",
                                    display: "block"
                                  }}
                                >
                                  <input
                                    name="payment_url"
                                    className="xsui-input xsui-input--size-md xsui-input--appearance-primary"
                                    type="text"
                                    data-id="payment_url"
                                    data-value="https://secure.xsolla.com/api/calc/billing/sample.universal.php"
                                    defaultValue="https://secure.xsolla.com/api/calc/billing/sample.universal.php"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>

                          <div style={{ width: "100%" }}>
                            <div>
                              <div className="ui-form__input-group ui-form__input-group--spaced">
                                <FormGroup
                                  label="User ID"
                                  tooltip="What's this"
                                >
                                  <Input
                                    // size="sm"
                                    name="basic-input"
                                    input={{
                                      value: "0",
                                      onChange: ()=>{void(0)}
                                    }}
                                  />
                                </FormGroup>

                                <FormGroup
                                  label="Xsolla Invoice ID"
                                  tooltip="What's this"
                                >
                                  <Input
                                    // size="sm"
                                    name="basic-input"
                                    input={{
                                      value: "0",
                                      onChange: ()=>{void(0)}
                                    }}
                                  />
                                </FormGroup>

                                <FormGroup label="Amount" tooltip="What's this">
                                  <Input
                                    // size="sm"
                                    name="basic-input"
                                    input={{
                                      value: "0",
                                      onChange: ()=>{void(0)}
                                    }}
                                  />
                                </FormGroup>
                              </div>

                              <div className="ui-form__input-group ui-form__input-group--spaced">
                                <FormGroup
                                  label="Currency"
                                  tooltip="What's this"
                                >
                                  <SelectExample
                                    // title="Currency"
                                    canBeEmpty={false}
                                    size="md"
                                    defaultValue={2}
                                    options={[
                                      { label: "All ", value: "all" },
                                      { label: "USD", value: "USD" },
                                      { label: "EUR", value: "EUR" },
                                      { label: "RUB", value: "EUR" }
                                    ]}
                                  />
                                </FormGroup>

                                <FormGroup
                                  label="Game key"
                                  tooltip="What's this"
                                >
                                  <Input
                                    // size="sm"
                                    name="basic-input"
                                    input={{
                                      value: "0",
                                      onChange: ()=>{void(0)}
                                    }}
                                  />
                                </FormGroup>

                                <FormGroup
                                  label="Invoice ID"
                                  tooltip="What's this"
                                >
                                  <Input
                                    // size="sm"
                                    name="basic-input"
                                    input={{
                                      value: "0",
                                      onChange: ()=>{void(0)}
                                    }}
                                  />
                                </FormGroup>
                              </div>

                              {/* <div className="ui-form__input-group ui-form__input-group--spaced">

                              </div> */}
                            </div>
                          </div>

                          {/* <div className="xsui-form-group xsui-form-group--primary xsui-form-group--direction-column xsui-form-group--indentation-md">
                            <div className="xsui-form-group__entry">
                              <div style={{ textAlign: "center" }}>
                                <button
                                  // onClick={this.props.handleWebhooks}
                                  onClick={e => {
                                    handleSteps(state.current + 1);
                                  }}
                                  className="xsui-button xsui-button--appearance-secondary xsui-button--size-sm"
                                  type="submit"
                                >
                                  Test Webhooks
                                </button>
                              </div>
                            </div> */}
                        </div>
                      </div>

                      <div className="xsui-form-footer xsui-form-footer--down xsui-form-footer--centered xsui-form-footer--sticky">
                        <div className="xsui-form-footer__entry">
                          <button
                            className="xsui-button xsui-button--appearance-primary xsui-button--size-md"
                            type="submit"
                            onClick={e => {
                              handleSteps(state.current + 1);
                            }}
                          >
                            Test Webhooks
                          </button>
                        </div>
                      </div>
                    </div>
                  )}

                  {state.current === 2 && (
                    <div style={{ width: "100%"}}>
                      <div className="testing-results__sandbox-url">
                      <div className="xsui-typography--subheader-2">
                        Sandbox URL
                      </div>
                      <a href="https://sandbox-secure.xsolla.com/paystation2/?access_token=qept0LJ6YahQU4xUC1FBNdxs1VAxwX1t"
                      className="testing-results__sandbox-url__link" target="_blank">
                        https://sandbox-secure.xsolla.com/paystation2/?access_token=qept0LJ6YahQU4xUC1FBNdxs1VAxwX1t
                      </a>
                    </div>




                      <div className="test-result">
                        <div className="test-result__header">
                          {/* Payment validation: Testing response to correct payment */}
                          <span className="test-result__header__title">
                            Testing response to correct payment
                          </span>
                          <p className="test-result__header__description">
                            When Xsolla requests a payment with correct
                            parameters, the project must respond with HTTP code
                            200. This tester requests to make a payment to an
                            existing user.
                          </p>
                          <p className="test-result__header__description">
                            <span>Total attempts: 2</span>
                          </p>
                        </div>
                          <div className="test-result__body">

                          <div className="webhooks-block__form">
                            <div className="test-result__body__attempt">
                            <div className="test-result__body__attempt__status">
                              <div className="xsui-status-dot xsui-status-dot--enabled">
                                <div className="xsui-status-dot__icon" />
                                <div className="xsui-status-dot__entry" />
                              </div>
                              <span>Attempt 1</span>
                              </div>

                              <Collapse
                                isOpened={false}
                                staticElements={0}
                                collapsedLabel={count => `Show details`}
                                expandedLabel={() => 'Hide details'}>
                                {[<FormGroup>
                                  <div>
                                    <div className="http__tabs">
                                      <div className="http__tabs__tab">Request</div>
                                      <div className="http__tabs__tab http__tabs__tab--active">
                                        Response
                                  </div>
                                    </div>
                                    <div className="http__content">
                                      <div className="http__content__headers">
                                        <div className="http__content__headers__item">
                                          <div className="http__content__headers__item__key">
                                            HTTP/1.1 204 No Content
                                      </div>
                                        </div>
                                        <div className="http__content__headers__item">
                                          <div className="http__content__headers__item__key">
                                            Server
                                      </div>
                                          <div className="http__content__headers__item__value">
                                            nginx
                                      </div>
                                        </div>
                                        <div className="http__content__headers__item">
                                          <div className="http__content__headers__item__key">
                                            Date
                                      </div>
                                          <div className="http__content__headers__item__value">
                                            Wed, 24 Apr 2019 16:54:56 GMT
                                      </div>
                                        </div>
                                        <div className="http__content__headers__item">
                                          <div className="http__content__headers__item__key">
                                            Content-Type
                                      </div>
                                          <div className="http__content__headers__item__value">
                                            text/html; charset=UTF-8
                                      </div>
                                        </div>
                                        <div className="http__content__headers__item">
                                          <div className="http__content__headers__item__key">
                                            Connection
                                      </div>
                                          <div className="http__content__headers__item__value">
                                            keep-alive
                                      </div>
                                        </div>
                                        <div className="http__content__headers__item">
                                          <div className="http__content__headers__item__key">
                                            X-NewRelic-App-Data
                                      </div>
                                          <div className="http__content__headers__item__value">
                                            PxQGUFZRDQETVVhTAQAOREgTYVYAMhEDXhFZAUxRW1xvSmwTWD0cAxRfa05MQRQDHlRRUgcBG1ZKAQYCW15PTwFOGgAIAVFXAVRbUlVVUlpSBwdDSgVZX0MBPA==
                                      </div>
                                        </div>
                                        <div className="http__content__headers__item">
                                          <div className="http__content__headers__item__key">
                                            Timing-Allow-Origin
                                      </div>
                                          <div className="http__content__headers__item__value">
                                            *
                                      </div>
                                        </div>
                                        <div className="http__content__headers__item">
                                          <div className="http__content__headers__item__key">
                                            Pragma
                                      </div>
                                          <div className="http__content__headers__item__value">
                                            no-cache
                                      </div>
                                        </div>
                                        <div className="http__content__headers__item">
                                          <div className="http__content__headers__item__key">
                                            Cache-Control
                                      </div>
                                          <div className="http__content__headers__item__value">
                                            no-cache, no-store, must-revalidate,
                                            max-age=0
                                      </div>
                                        </div>
                                        <div className="http__content__headers__item">
                                          <div className="http__content__headers__item__key">
                                            Set-Cookie
                                      </div>
                                          <div className="http__content__headers__item__value">
                                            split_mode=0;Max-age=600;path=/
                                      </div>
                                        </div>
                                      </div>
                                      <div className="http__content__body">
                                        Not enough data available
                                  </div>
                                    </div>
                                  </div>
                                </FormGroup>]}
                            </Collapse>

                            </div>
                          </div>
                          <div className="webhooks-block__form">
                            <div className="test-result__body__attempt">
                            <div className="test-result__body__attempt__status">
                              <StatusDot status="error" />
                              <span>Attempt 2</span>
                              </div>

                              <Collapse
                                isOpened={true}
                                staticElements={0}
                                collapsedLabel={count => `Show details`}
                                expandedLabel={() => 'Hide details'}>
                                {[<FormGroup>
                            <div>
                              <div>
                                <div className="http__tabs">
                                  <div className="http__tabs__tab">Request</div>
                                  <div className="http__tabs__tab http__tabs__tab--active">
                                    Response
                                  </div>
                                </div>
                                <div className="http__content">
                                  <div className="http__content__headers">
                                    <div className="http__content__headers__item">
                                      <div className="http__content__headers__item__key">
                                        HTTP/1.1 204 No Content
                                      </div>
                                    </div>
                                    <div className="http__content__headers__item">
                                      <div className="http__content__headers__item__key">
                                        Server
                                      </div>
                                      <div className="http__content__headers__item__value">
                                        nginx
                                      </div>
                                    </div>
                                    <div className="http__content__headers__item">
                                      <div className="http__content__headers__item__key">
                                        Date
                                      </div>
                                      <div className="http__content__headers__item__value">
                                        Wed, 24 Apr 2019 16:54:56 GMT
                                      </div>
                                    </div>
                                    <div className="http__content__headers__item">
                                      <div className="http__content__headers__item__key">
                                        Content-Type
                                      </div>
                                      <div className="http__content__headers__item__value">
                                        text/html; charset=UTF-8
                                      </div>
                                    </div>
                                    <div className="http__content__headers__item">
                                      <div className="http__content__headers__item__key">
                                        Connection
                                      </div>
                                      <div className="http__content__headers__item__value">
                                        keep-alive
                                      </div>
                                    </div>
                                    <div className="http__content__headers__item">
                                      <div className="http__content__headers__item__key">
                                        X-NewRelic-App-Data
                                      </div>
                                      <div className="http__content__headers__item__value">
                                        PxQGUFZRDQETVVhTAQAOREgTYVYAMhEDXhFZAUxRW1xvSmwTWD0cAxRfa05MQRQDHlRRUgcBG1ZKAQYBW1dPTwFOGgNcCgdXBAcPAFVQBFUBVQRDSgVZX0MBPA==
                                      </div>
                                    </div>
                                    <div className="http__content__headers__item">
                                      <div className="http__content__headers__item__key">
                                        Timing-Allow-Origin
                                      </div>
                                      <div className="http__content__headers__item__value">
                                        *
                                      </div>
                                    </div>
                                    <div className="http__content__headers__item">
                                      <div className="http__content__headers__item__key">
                                        Pragma
                                      </div>
                                      <div className="http__content__headers__item__value">
                                        no-cache
                                      </div>
                                    </div>
                                    <div className="http__content__headers__item">
                                      <div className="http__content__headers__item__key">
                                        Cache-Control
                                      </div>
                                      <div className="http__content__headers__item__value">
                                        no-cache, no-store, must-revalidate,
                                        max-age=0
                                      </div>
                                    </div>
                                    <div className="http__content__headers__item">
                                      <div className="http__content__headers__item__key">
                                        Set-Cookie
                                      </div>
                                      <div className="http__content__headers__item__value">
                                        split_mode=0;Max-age=600;path=/
                                      </div>
                                    </div>
                                  </div>
                                  <div className="http__content__body">
                                    Not enough data available
                                  </div>
                                </div>
                              </div>
                                  </div>
                                  </FormGroup>]}</Collapse>
                          </div>
                          </div>


                          </div>
                      </div>




                      <div className="xsui-form-footer xsui-form-footer--down xsui-form-footer--centered xsui-form-footer--sticky">
                        <div className="xsui-form-footer__entry">
                          <Button
                            style={{
                              position: "absolute",
                              left: 0,
                              color: "#747e8a"
                            }}
                            appearance="flatten"
                            onClick={e => {
                              handleSteps(state.current - 1);
                            }}
                          >
                            <Icon name="chevron-reverse" />
                          </Button>

                          <button
                            className="xsui-button xsui-button--appearance-primary xsui-button--size-md"
                            type="submit"
                            onClick={() => closeModal(true)}
                          >
                            Use Webhooks
                          </button>
                        </div>
                      </div>
                    </div>

                  )}

                  {/* </form> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );

}
